// extracted by mini-css-extract-plugin
export default {"root":"AgentApplyNow_root__Vgu3E"};